<template>
  <div>
    <v-main>
      <v-container fluid>
        <v-card id="titlecard" flat>
          <v-row cols="12" dense>
            <v-col cols="12">
              <h2>{{ this.title }}</h2>
              <h5 class="subtitle-weight">(Nr. of rebookings in selection: {{ this.filteredRebookings.length }})</h5>
            </v-col>
          </v-row>
          <v-row dense cols="12">
            <v-col cols="2">
              <v-text-field v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields"
                single-line hide-detail />
            </v-col>
            <v-col cols="2" v-if="params[0] != 'user'" class="pl-4">
              <select_gebr :selected_gebr="selected_gebr" field="selected_gebr" label="Assigned to" :isDense="false"
                :isClearable="true" @updateData="updateData" />
            </v-col>
            <v-col cols="1" class="pl-4 pt-6">
              <date_picker label="Arrival from" icon="mdi-calendar" :date="arrivalDateFromISO"
                field="arrivalDateFromISO" @updateData="updateData" />
            </v-col>
            <v-col cols="1" class="pl-4 pt-6">
              <date_picker label="Arrival until" icon="mdi-calendar" :date="arrivalDateUntilISO"
                field="arrivalDateUntilISO" @updateData="updateData" />
            </v-col>
            <v-col cols="3" class="pl-4">
              <filter_eventstatus :selected_stats="selected_omst" label="Status" field="selected_omst"
                :isClearable="true" @updateData="updateData" :showClosed="showClosed" ref="cbo_eventstatus" />
            </v-col>
            <v-col cols="1" class="pl-8 pt-6">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-spacer />
                  <v-icon v-bind="attrs" v-on="on" medium color="green"
                    v-on:click="exportDataToExcel()">mdi-microsoft-excel</v-icon>
                </template>
                <span>Export data to Excel</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card>
        <v-row class="row-default">
          <v-col cols="12" class="px-2">
            <v-data-table id="x" dense :headers="getHombHeaders()" :items="filteredRebookings" :disable-pagination=true
              hide-default-footer item-key="activity" :loading="loading" loading-text="Loading data...please wait"
              fixed-header :search="search" :height="wInnerHeight">
              <template v-slot:header.attachments>
                <v-icon small>mdi-paperclip</v-icon>
              </template>
              <template v-slot:header.sort>
                <v-icon small>mdi-flag-variant-outline</v-icon>
              </template>
              <template v-slot:item="rebooking">
                <tr>
                  <td class="td_markup">
                    <table>
                      <tr>
                        <td class="row-pointer booking-color td_markup_inner">
                          <span v-on:click="$router.open('/huov/onHuov/' + rebooking.item.huov_encrid)">{{ rebooking.item.booking }}</span>
                        </td>
                      </tr>
                      <tr v-if="rebooking.item.partner !== ''">
                        <td>
                          {{ rebooking.item.partner }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="td_markup_xs">{{ rebooking.item.arrival_dmy }}</span>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td class="td_markup"><div v-if="rebooking.item.cttp_nr==='5'"><v-icon color="error" size="20">mdi-alpha-e-circle</v-icon></div></td>
                  <td class="td_markup">
                    {{ $moment(rebooking.item.created).format("DD-MM-YYYY HH:mm") }}
                  </td>
                  <td class="td_markup">{{ rebooking.item.homb_initiatief }}</td>
                  <td class="td_markup">
                    <table v-for="contact, idx in rebooking.item.contacts" :key=idx
                      style="border-collapse:collapse !important; font-size: 12px !important;">
                      <tr :class="{ 'border-xs': !(idx + 1 === (rebooking.item.contacts.length)) }">
                        <td
                          :class="{ 'td-markup-xs': true, 'td-code': true, 'border-xs': !(idx + 1 === (rebooking.item.contacts.length)) }">
                          {{ contact.desc }}</td>
                        <td
                          :class="{ 'td-markup-xs': true, 'td-name': true, 'border-xs': !(idx + 1 === (rebooking.item.contacts.length)) }">
                          <span v-if="contact.desc === 'Guest'" v-on:click="$router.open('/klnt/onKlnt/' + contact.encrid)"  :class="{'booking-color': true, 'row-pointer': true}">
                            {{ contact.naam }}
                          </span>
                         <span v-else-if="contact.desc === 'Rental expert'" :class="{'booking-color': false, 'row-pointer': false}">
                            {{ contact.naam }}
                          </span>
                          <span v-else v-on:click="$router.open('/eign/onEign/' + contact.encrid)" :class="{'booking-color': true, 'row-pointer': true}">
                            {{ contact.naam }}
                          </span>
                        </td>
                      </tr>
                    </table>                    
                  </td>            
                  <td class=" td_markup" v-if="params[0] !== 'huis'">
                    <table>
                      <tr>
                        <td class="td_markup_inner">
                          <span
                            v-on:click="$router.open('/huis/onHuis/' + rebooking.item.huis_encrid)" class="booking-color row-pointer">{{
                            rebooking.item.accommodation }}
                          </span>
                        </td>
                      </tr>
                    </table>
                  </td>     
                  <td class="td_markup">{{ rebooking.item.assigned_displayname }}</td>
                  <td class="td_markup">{{ rebooking.item.reason_code_desc }}</td>
                  <td class="td_markup">{{ rebooking.item.subreason_code_desc }}</td>                  
                  <td class="td_markup">
                    <v-tooltip bottom :max-width="400" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          {{ rebooking.item.rebooking_info && rebooking.item.rebooking_info.length > 75 ? rebooking.item.rebooking_info.substring(0, 75) + '...' : rebooking.item.rebooking_info }}
                        </span>
                      </template>
                      <span>{{ rebooking.item.rebooking_info }}</span>
                    </v-tooltip>
                  </td>
                  <td class="td_markup">
                    <v-tooltip bottom :max-width="400" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          {{ rebooking.item.homb_alternatief && rebooking.item.homb_alternatief.length > 75 ? rebooking.item.homb_alternatief.substring(0, 75) + '...' : rebooking.item.homb_alternatief }}
                        </span>
                      </template>
                      <span>{{ rebooking.item.homb_alternatief }}</span>
                    </v-tooltip>
                  </td>
                  <td class="td_markup">{{ $moment(rebooking.item.modified).format("DD-MM-YYYY HH:mm") }}</td>
                  <td class="td_markup">
                    <v-tooltip bottom :max-width="400" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          {{ rebooking.item.summary && rebooking.item.summary.length > 75 ? rebooking.item.summary.substring(0, 75) + '...' : rebooking.item.summary }}
                        </span>
                      </template>
                      <span>{{ rebooking.item.summary }}</span>
                    </v-tooltip>
                  </td>
                  <td class="td_markup">{{ rebooking.item.homb_omst_display }}</td>
                  <td class="td_markup" align="center">
                    <div v-if="!!rebooking.item.attachments">
                      {{ rebooking.item.attachments }}
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <div v-if="this.params[0] == 'all'">
      <navBar title="Ares - Customer Success" :home="true" type="customersuccess" goto="/task/customer_success/mnCustomerSuccess" />
    </div>
    <div v-else>
      <navBar title="Ares - Overview" :home="true" goto="/task/customer_success/mnCustomerSuccess" />
    </div>
  </div>
</template>

<script>
import select_gebr from '@/components/ui/selectors/select_gebr.vue'
import filter_eventstatus from '@/components/huov/homb/ui/filter_eventstatus.vue'
import date_picker from '@/components/ui/date_picker.vue';

import navBar from "@/components/ui/navbars/navbar.vue";

//import longTextView from "@/views/task/customer_success/homb/longTextView";

export default {
  props: ['param'],
  components: {
    navBar,
    select_gebr,
    filter_eventstatus,
    date_picker,
    //longTextView
  },
  data() {
    return {
      search: '',
      text_max_width: 150,     // For all long texts
      rebookings: [],
      loading: false,
      params: [],
      selected_gebr: null,
      selected_omst: [],
      bar_height: 0,
      card_height: 0,
      arrivalDateFromISO: null,
      arrivalDateUntilISO: null,
      wInnerHeight: window.innerHeight - 290, // deduct estimated height for toolbar, searchfield and headers
      title: 'Pending rebookings overview',
      showClosed: false
    }
  },
  created() { // set up event bus listener here on created event or get data
    window.addEventListener("resize", this.resizeEventHandler);

    if (this.param != null) {
      this.params = this.param.split(":");
      if (this.params[0] ===  'huis-ovb') this.showClosed=true // gerommel en vetzakkerij
    }
    this.getOverview();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  mounted() {
  },
  computed: {  // Dit is traaaaaaag....
    filteredRebookings: function () {
      return this.rebookings.filter((rebooking) => {
        // status
        if (this.selected_omst !== null && this.selected_omst.length !== 0) {
          let matches_status = false;
          for (let idx = 0; idx < this.selected_omst.length; idx++) {
            if (rebooking.homb_omst === this.selected_omst[idx]) {
              matches_status = true;
              break;
            }
          }
          if (!matches_status) {
            return false;
          }
        }

        // user
        if (this.selected_gebr !== null) {
          if (rebooking.assigned !== this.selected_gebr) {
            return false;
          }
        }

        // dates
        if (this.arrivalDateFromISO !== null) {
          if (rebooking.arrival < this.arrivalDateFromISO) {
            return false;
          }
        }
        if (this.arrivalDateUntilISO !== null) {
          if (rebooking.arrival > this.arrivalDateUntilISO) {
            return false;
          }
        }

        return true;
      });
    },
  },
  methods: {
    updateData(data) {
      this[data.field] = data.value;
    },
    resizeEventHandler() {
      this.wInnerHeight = window.innerHeight - 290; // deduct estimated height for toolbar, searchfield and headers
    },
    getOverview() {
      if (this.params[0] === 'huis-ovb') this.params[0]='huis' // vetzakkerij
      // console.log(this.params)
      this.loading = true;
      this.$axios
        .post("ares/json/ares/task/customer_success/homb/getHombOverviewV4.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHombOverview"
          },
          getHombOverview: {
            params: this.params,
          }
        })
        .then(res => {
          // console.log(res.data)
          if (res.data.header.result == "error") {
            console.log(res.data.error);
          } else {
            this.rebookings = res.data.getHombOverview;
            this.title += (' ' + res.data.header.entityvalue);
            this.$refs.cbo_eventstatus.fixDropDown(res.data.header.state === 'open')
          }
          this.loading = false;
        })
    },
    getHombHeaders() {
      switch (this.params[0]) {
        case 'all':
        case 'klnt':
        case 'user':
        case 'eign':
          return [
            { text: "Booking Arrival", value: "booking", sortable: true, width: '5%' },
            { text: "Ctr", value: "cttp_nr", width: "4%", align: "center", sortable: true },
            { text: "Filed", value: "created", sortable: true, width: '6%' },
            { text: "Caused", value: "homb_initiatief", sortable: true, width: '5%' },
            { text: "Contacts", value: "", sortable: false, width: '12%' },
            { text: "Accom.", value: "accommodation", sortable: true, width: '5%' },
            { text: "Assigned", value: "assigned", sortable: true, width: '6%' },
            { text: "Reason", value: "reason_code_desc", sortable: false, width: '6%' },
            { text: "Subreason", value: "subreason_code_desc", sortable: false, width: '10%' },
            { text: "Rebooking information", value: "rebooking_info", sortable: false, width: '10%' },
            { text: "alternatives", value: "homb_alternatief", sortable: false, width: '10%' },            
            { text: "Upd.", value: "modified", sortable: true, width: '6%' },
            { text: "Latest development", value: "summary", sortable: false, width: '10%' },
            { text: "Stat", value: "homb_omst_display", sortable: true, width: '10%' },
            { sortable: false, value: "attachments", align: "center", width: '1%' },
          ];
        case 'huis':
          return [
            { text: "Booking/Arrival", value: "booking", sortable: true, width: '5%' },
            { text: "Ctr", value: "cttp_nr", width: "4%", align: "center", sortable: true },
            { text: "Filed", value: "created_dmy", sortable: true, width: '6%' },
            { text: "Caused", value: "homb_initiatief", sortable: true, width: '5%' },
            { text: "Contacts", value: "", sortable: false, width: '12%' },
            { text: "Assigned", value: "assigned", sortable: true, width: '6%' },
            { text: "Reason", value: "reason_code_desc", sortable: false, width: '6%' },
            { text: "Subreason", value: "subreason_code_desc", sortable: false, width: '10%' },            
            { text: "Rebooking information", value: "rebooking_info", sortable: false, width: '10%' },
            { text: "alternatives", value: "homb_alternatief", sortable: false, width: '10%' },
            { text: "Upd.", value: "modified", sortable: true, width: '6%' },
            { text: "Latest development", value: "summary", sortable: false, width: '10%' },
            { text: "Status", value: "homb_omst_display", sortable: true, width: '10%' },
            { sortable: false, value: "attachments", align: "center", width: '1%' },
          ];

      }
    },
    exportDataToExcel() {

      let e_rebookings = [];

      for (let t = 0; t < this.filteredRebookings.length; t++) {

        let el = new Object();

        el["Booking"] = this.filteredRebookings[t].booking;
        el["Partner"] = this.filteredRebookings[t].partner;
        el["Arrival"] = new Date(this.filteredRebookings[t].arrival);
        el["Filed"] = new Date(this.filteredRebookings[t].created)
        el["Caused by"] = this.filteredRebookings[t].homb_initiatief;
        this.filteredRebookings[t].contacts.forEach(element => {
          el[`${element.desc}`] = element.naam;
        }); 
        el["Accommodation"] = this.filteredRebookings[t].accommodation;
        el["Live"] = new Date(this.filteredRebookings[t].d_date);
        el["Tot. B-STD bookings"] = this.filteredRebookings[t].num_bookings;
        el["Assigned to"] = this.filteredRebookings[t].assigned_displayname;
        el["Reason"] = this.filteredRebookings[t].reason_code_desc;
        el["Subreason"] = this.filteredRebookings[t].subreason_code_desc;
        el["Rebooking info"] = this.filteredRebookings[t].rebooking_info;
        el["Latest Development"] = this.filteredRebookings[t].summary;
        el["Alternatives"] = this.filteredRebookings[t].homb_alternatief;
        el["Alt. booking"] = this.filteredRebookings[t].homb_alt_huov;
        el["Modified"] = new Date(this.filteredRebookings[t].modified); // formatted so it can be sorted as a date in Excel
        el["Status"] = this.filteredRebookings[t].homb_omst_display;
        el["Closed"] = (this.filteredRebookings[t].num_closed_events);
        el["Attachments"] = this.filteredRebookings[t].attachments;

        e_rebookings.push(el);

      }

      var XLSX = require("xlsx");
      var ws = XLSX.utils.json_to_sheet(e_rebookings);
      var wb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, "Rebookings");
      XLSX.writeFile(wb, 'Rebookings.xlsx');
    },
    convertTextToHtml(text) {
      return text.replace(/\n/gi, '<br>'); // yes indeed, regular expression!!
    }
  }
}

</script>

<style scoped>
.row-pointer {
  cursor: pointer;
}

.row-default {
  cursor: default;
}

.booking-color {
  color: blue;
}

.no-booking-color {
  color: black;
}

.subtitle-weight {
  font-weight: 400;
}

.td_markup {
  vertical-align: top;
  border-top: 5px solid transparent !important;
  font-size: 12px !important;
  /* trick to add padding to a TD element (which is not possible with CSS normally) */
}

.td_markup_inner {
  vertical-align: top;
  /* border-top: 5px solid transparent; */
  border-top: 0px solid transparent !important;
  font-size: 12px !important;
  /* trick to add padding to a TD element (which is not possible with CSS normally) */
}

.td-code {
  width: 7.5em;
}

.td-name {
  width: 8em;
}

.td-amount {
  width: 5em;
  text-align: end !important;
}

.td-markup-xs {
  padding-top: 1px;
  padding-bottom: 2px;
  vertical-align: top;
}

.border-xs {
  border-bottom: 1px solid lightgrey;
}
</style>